import type { CSSProperties } from 'react';
import { forwardRef } from 'react';
import type { VideoURLValue } from '@elfsight/configurator-contracts';
import type { MediaVideoProps, PlayerAPI } from '@elfsight/widget-media-video';
import { MediaVideo } from '@elfsight/widget-media-video';

export { PlayerAPI };

export type BaseVideoBlockProps = MediaVideoProps & {
  src: VideoURLValue;
  scale?: number;
};

export const BaseVideoBlock = forwardRef<PlayerAPI, BaseVideoBlockProps>(
  (
    { src, scale = 100, ratio, borderRadius, className, style },
    forwardingRef
  ) => {
    const defaultStyle: CSSProperties = {
      width: `${scale}%`
    };

    return (
      <MediaVideo
        ref={forwardingRef}
        className={className}
        src={src?.originalValue}
        ratio={ratio}
        playerRatio={ratio}
        borderRadius={borderRadius}
        style={{ ...style, ...defaultStyle }}
      />
    );
  }
);
